import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reduxLoggerMiddleware from '../tools/redux-logger-middleware';
import reducers from '../reducers';
import sagas from '../sagas';
import config from '../config';
import { middleware as idleMiddleware } from '../tools/idle-monitor';
import { trackAnalyticsReduxMiddleware as trackGoogleAnalytics } from '../tools/google-analytics';
import { thunk } from 'redux-middleware';

const sagaMiddleware = createSagaMiddleware();
let middlewares = [sagaMiddleware, thunk, idleMiddleware, trackGoogleAnalytics];

if (config.logReduxActions) {
  middlewares.push(reduxLoggerMiddleware);
}

export function applyMiddlewares() {
  if ([...arguments].length) {
    middlewares = middlewares.concat([...arguments]);
  }
}

export const createReduxStore = () => {
  const store = createStore(
    reducers,
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__(),
    applyMiddleware(...middlewares)
  );

  sagaMiddleware.run(sagas);

  return store;
};



// WEBPACK FOOTER //
// ./src/store/store-creator.js